import { render, staticRenderFns } from "./DuplicateEventHistoryPopup.vue?vue&type=template&id=5f030831&scoped=true&"
import script from "./DuplicateEventHistoryPopup.vue?vue&type=script&lang=js&"
export * from "./DuplicateEventHistoryPopup.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateEventHistoryPopup.vue?vue&type=style&index=0&id=5f030831&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f030831",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VIcon,VMenu})
